module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('div', {
    attrs: {
      "id": "x03_9781118181393-flast.html"
    }
  }, [_c('div', {
    staticClass: "story"
  }, [_c('p', {
    staticClass: "JFC-Text-Subhead"
  }, [_vm._v("ACKNOWLEDGMENTS")]), _vm._v(" "), _c('p', {
    staticClass: "JFC-Text-Body-P1"
  }, [_vm._v("Nearly 25,000 pounds lost . . . and a group of dedicated professionals made this book possible.")]), _vm._v(" "), _c('p', {
    staticClass: "JFC-Text-Body"
  }, [_vm._v("Special thanks to my editorial director, Johannah Sakimura. Your enthusiasm and ability to articulate, organize, fact check, and keep me on a tight schedule is of immeasurable value. To Catherine Whitney for     shaping each and every feature into a compelling read with compassion and grace. To my literary agents, Jane Dystel and Miriam Goderich, for your reliable advice and enduring support.")]), _vm._v(" "), _c('p', {
    staticClass: "JFC-Text-Body"
  }, [_vm._v("To Jim Bell, "), _c('span', {
    staticClass: "zItalic"
  }, [_vm._v("Today’s")]), _vm._v(" EP extraordinaire, who gave me my dream job and the opportunity to grow it into something truly special. To my Joy Fit Club on-air powerhouse team: Hoda Kotb, Kathie Lee Gifford, Tammy Filler, Christine Cataldi, Jayme Baron, Melanie Jackson, Emily Goldberg, Liz Neumann, Ed Helbig, April Bartlett, and Bianca Henry (Lish and Alli too). I’m very lucky to be backed up by so much enthusiasm and talent. You make everything possible.")]), _vm._v(" "), _c('p', {
    staticClass: "JFC-Text-Body"
  }, [_vm._v("My deepest gratitude to Jaclyn Levin at "), _c('span', {
    staticClass: "zItalic"
  }, [_vm._v("Today")]), _vm._v(" who believed in this book from the beginning and helped it become a reality. I am also thankful to the team at NBC, including Kim Niemi, Amy Nichols, Ed Prince, Chris Lucero, Steve Coulter, Neysa Siefert, Joni Camacho, Joseph Ford, Stan Pottinger, Richard Greenberg, and Steve Chung, for their professionalism and support. And to Amy Rosenblum for creating the on-air series.")]), _vm._v(" "), _c('p', {
    staticClass: "JFC-Text-Body"
  }, [_vm._v("I am grateful to all my friends at "), _c('span', {
    staticClass: "zItalic"
  }, [_vm._v("Today")]), _vm._v(" for continuously supporting my health efforts: Steve Capus, Phil Griffin, Don Nash, Elena Nachmanoff, Noah Kotch, Debbie Kosofsky, Marc Victor, Rainy Farrell, and the countless producers and assistants who help me each week. The wonderful "), _c('span', {
    staticClass: "zItalic"
  }, [_vm._v("Today")]), _vm._v(" hosts make my job easier and are a real pleasure: Matt Lauer, Ann Curry, Al Roker, Natalie Morales, Savannah Guthrie, Lester Holt, Tamron Hall, Jenna Wolfe, Amy Robach, and medical guru, Dr. Nancy Snyderman. Also, I am indebted to the hardworking stage crew, prop department, wardrobe, hair and makeup staffs, as well as the exceptional staff at "), _c('a', {
    attrs: {
      "href": "http://TODAY.com",
      "target": "_blank"
    }
  }, [_vm._v("TODAY.com")]), _vm._v(".")]), _vm._v(" "), _c('p', {
    staticClass: "JFC-Text-Body"
  }, [_vm._v("Thanks to everyone at Wiley who produced such a stunning product. In particular, my unflappable and talented editor, Justin Schwartz, deserves my admiration and gratitude. Justin, I loved working with you. Many thanks to the fabulous Lisa Kingsley, Ken Carlson, and their entire production team, including Laura Marzen, and to our topnotch photographer Lucy Schaeffer.")]), _vm._v(" "), _c('p', {
    staticClass: "JFC-Text-Body"
  }, [_vm._v("The 30 Joy Fit Club members profiled in this book, along with every other amazing Fit Club member who has appeared on "), _c('span', {
    staticClass: "zItalic"
  }, [_vm._v("Today")]), _vm._v(", have earned my love and respect for their remarkable courage and determination. I am thrilled to be able to introduce them to readers as proof that people can lose weight and keep it off for good. My Joy Fit Club members always tell me how motivated they are to help others, and by sharing their stories with the world they are doing just that.")]), _vm._v(" "), _c('p', {
    staticClass: "JFC-Text-Body"
  }, [_vm._v("Special thanks to my agents at CAA: Olivia Metzger, Katie Maloney, Stephanie Paciullo, Ashley Davis, Gary Krakower, Will Hobbs, Carla Laur, and Lisa Shotland. And to Theresa Brown, Bethany Dick, and Jeff Lesh at WME.  ")]), _vm._v(" "), _c('p', {
    staticClass: "JFC-Text-Body"
  }, [_vm._v("Finally, hugs to everyone in my wonderful family (all 30 of you!), especially my mom and dad (Ellen and Artie Schloss); my other mom and dad (Carol and Victor Bauer), and my personal “Fit Club” members who regularly play double duty as recipe guinea pigs—my husband Ian and three kids, Jesse, Cole and Ayden.   ")]), _vm._v(" "), _c('p', {
    staticClass: "JFC-Text-Body"
  }, [_c('img', {
    attrs: {
      "alt": "",
      "src": "images/JBauer_SIG_fmt.png"
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "image"
  }, [_c('p', {
    staticClass: "para-style-override-1",
    staticStyle: {
      "page-break-before": "always",
      "text-align": "center"
    }
  }, [_c('img', {
    attrs: {
      "alt": "",
      "src": "images/9781118181393-fm08_fmt.png"
    }
  })])])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-874d101c","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/03_9781118181393flast.vue
// module id = 63
// module chunks = 0